module.exports = __webpack_public_path__ + "static/media/marseille-16.ba6bc875.jpg";